/* ============================================================
   KWD TISHREI 5787 — SHARED CATALOG AND CASE STATE
   One source of truth for the banner (index.html) and the
   portal (portal.html). In the theme this becomes a snippet or
   a metaobject; nothing here should be duplicated per page.

   CURATION IS DRIVEN BY THREE TISHREI SEASONS OF ACTUAL SALES,
   not by taste. ShopifyQL, net sales by product:

     2023 (Aug 15-Oct 10)  2024 (Sep 1-Oct 25)   2025 (Aug 20-Oct 15)
   1 Tubi 60      $5,626   Tubi 60      $4,804   Tubi 60      $1,830
   2 Whispering A $3,509   JG Elite Arak $3,889  JG Elite Arak $1,508
   3 JG Elite Ark $2,996   Zachlawi Fig $1,485   Askalon Arak   $964
   4 Castel Rose  $2,205   Askalon Arak $1,218   Zachlawi Fig   $886

   Trailing 13 months by orders: Tubi 60 (170 / $21.3k), Joseph
   Gold Elite Arak (106 / $16.6k), Zachlawi Fig (100 / $9.8k).

   Two conclusions that overturned the first draft of this list:
   1. Tishrei is an ARAK AND SPIRITS season. Anise spirits take
      the top slots every year. Tubi 60 is the best selling
      product in the store and was missing entirely at first.
   2. The $8-$10 kiddush bottles (Kedem Cream Rose, Farbrengen,
      Kesser Concord) appear in the top 40 by revenue in NONE of
      the three years. Dropped. The semi-sweets that DO earn are
      the $13-$30 tier: Rashi Joyvin ($6.6k), Bartenura Malvasia
      ($4.5k), GRW Kindzmarauli ($3.7k), Zmora ($3.6k).

   Order within each moment matters: the banner shows only the
   first four cards on desktop.

   All variant IDs are live and were availableForSale at build.
   No -pos handles: those duplicates 404 on the storefront.
   ============================================================ */
(function (root) {
"use strict";

var CDN  = "https://cdn.shopify.com/s/files/1/0076/4392/2502/";
var SHOP = "https://kosherwinedirect.com/products/";
var STORE_HOST = /(^|\.)kosherwinedirect\.com$/;

function P(t,h,v,pr,img,role,why,size,style,mev){
  return {t:t,h:h,v:v,pr:pr,img:CDN+img,role:role,why:why,size:size,style:style,mev:mev};
}

var MOMENTS = [
 { key:"first", label:"First Night", blurb:"Kiddush, the simanim, and a sweet year", items:[
  P("Psagot De'Vine Semi-Sweet Red (750ml)","psagot-devine-semi-sweet-red-750ml","32179497107549",29.99,"files/psagot-de-vine.jpg?v=1781568000",
    "Semi-sweet, done properly","Semi-sweet is what actually empties at a yom tov table. This is the Judean Hills version of it.","750ml","Semi-sweet","Mevushal"),
  P("GRW Kindzmarauli (750ml)","grw-kindzmarauli-750ml","43899501314266",17.99,"files/grw-kindzmarauli-750ml.jpg?v=1782681429",
    "Quietly one of our best","Georgian semi-sweet. It does more revenue per order than almost anything at this price.","750ml","Semi-sweet","Mevushal"),
  P("Bartenura Malvasia di Casorzo (750ml)","bartenura-malvasia-di-casorzo-750ml","29453726908486",15.49,"files/bartenura-malvasia.jpg?v=1782238435",
    "Sparkling, sweet, red","Covers kiddush, the simanim and dessert in one bottle. It sells all year and peaks now.","750ml","Sweet sparkling","Mevushal"),
  P("Zmora Cabernet Sauvignon Semi Sweet (750ml)","zmora-cabernet-sauvignon-semi-sweet-750ml","29450084220998",12.99,"files/zmora-cabernet-sauvignon-semi-sweet-750ml.jpg?v=1783011729",
    "The reorder bottle","People who buy this once buy it again. Semi-sweet Cabernet at thirteen dollars.","750ml","Semi-sweet","Mevushal"),
  P("Bartenura Moscato (750ml)","bartenura-moscato-750ml","20480494403654",13.79,"files/bartenura-moscato.jpg?v=1782238414",
    "The one everybody knows","Lands on more Rosh Hashanah tables than any other bottle, and nobody needs it explained.","750ml","Sweet","Mevushal"),
  P("Rashi Joyvin Red (750ml)","rashi-joyvin-red-750ml","29446184566854",11.99,"files/rashi-joyvin-red-750ml.jpg?v=1783011725",
    "Bought by the armful","Rarely a single bottle. This goes into the cart four and six at a time.","750ml","Semi-sweet","Mevushal")]},

 { key:"threeday", label:"The Three Day Yom Tov", blurb:"Friday into Shabbos, no store run, nothing to chill", items:[
  P("Psagot Sinai (1.5L)","psagot-sinai-kosher-red-wine-1-5l","32286870208605",135.00,"files/psagot-sinai-1-5l.jpg?v=1781705893",
    "The magnum that gets remembered","A three day yom tov is the one time a magnum makes complete sense.","1.5L","Dry","Mevushal"),
  P("Chateau Les Riganes Bordeaux (1.5L)","chateau-les-riganes-1-5l","44627611156698",59.99,"files/chateau-les-riganes-1-5l.jpg?v=1782758886",
    "Three days, one bottle","Open it Friday night and it is still the wine on the table Sunday. Mevushal, so anybody can pour.","1.5L","Dry","Mevushal"),
  P("Binyamina Yogev Cabernet Shiraz (750ml)","binyamina-yogev-cabernet-shiraz-750ml","29493155627078",18.99,"files/binyamina-yogev-cz.jpg?v=1782247431",
    "The middle of the run","Day two and day three you want something good but not precious.","750ml","Dry","Mevushal"),
  P("Les Riganes Semi Dry White (750ml)","les-riganes-semi-dry-white-bordeaux-750ml","29449867526214",15.99,"files/les-riganes-semi-dry-white-bordeaux-750ml.jpg?v=1783011727",
    "The day meal","Lunch on a hot September day is not a dry red. Chill it before yom tov comes in.","750ml","Semi-dry","Mevushal"),
  P("Psagot Sinai (750ml)","psagot-sinai-750ml","29468629073990",27.99,"files/psagot-sinai.jpg?v=1782244495",
    "The serious mevushal red","Most mevushal reds are a compromise. This one is not.","750ml","Dry","Mevushal"),
  P("Bartenura Moscato (375ml)","bartenura-moscato-375ml","29456108912710",9.99,"files/bartenura-moscato-375.jpg?v=1782244494",
    "Nothing goes to waste","Half bottles exist for exactly this. Day three you open one more.","375ml","Sweet","Mevushal")]},

 { key:"break", label:"Break Fast", blurb:"After 25 hours, light and cold beats big", items:[
  P("Bartenura Malvasia di Casorzo (750ml)","bartenura-malvasia-di-casorzo-750ml","29453726908486",15.49,"files/bartenura-malvasia.jpg?v=1782238435",
    "The break fast bottle","Sweet, sparkling, low and cold. This is the night it was built for.","750ml","Sweet sparkling","Mevushal"),
  P("Mount Hermon Moscato (750ml)","mount-hermon-moscato-750ml","47239824507098",18.99,"files/mount-hermon-moscato-750ml.jpg?v=1783286023",
    "Low alcohol, on purpose","Coming off a fast people drink fast. A heavy wine on an empty stomach is a mistake.","750ml","Sweet","Mevushal"),
  P("Bartenura Moscato Cans (4 Pack)","bartenura-moscato-cans-4-pack","32517120720989",18.99,"files/w041.jpg?v=1782680833",
    "No corkscrew, no waiting","Nobody wants to be opening bottles the second the fast ends.","4 x 250ml","Sweet","Mevushal"),
  P("Morad Lychee Wine (750ml)","morad-lychee-wine-750ml","29553019617350",24.99,"products/Morad_Lychee_Wine.jpg?v=1573154823",
    "The one people ask about","Fruit wine reads as a treat rather than as wine, which is the mood when the fast is over.","750ml","Sweet","Mevushal"),
  P("Clos 15 Cava Semi-Sweet (750ml)","clos-15-cava-semi-sweet-750ml","47556409163994",15.99,"files/clos-15-cava-semi-sweet-750ml_b564e939-87d8-41f3-aaf6-9d3127ff1122.jpg?v=1783298111",
    "Bubbles, not brut","Semi-sweet is far kinder than a dry brut after a fast.","750ml","Semi-sweet","Mevushal"),
  P("Hagafen Sauvignon Blanc (750ml)","hagafen-sauvignon-blanc-750ml","29519791980614",19.99,"files/hagafen-sb.jpg?v=1782247458",
    "If you want dry","Not everybody wants sweet at break fast. A crisp Napa white still goes down easy.","750ml","Dry","Mevushal")]},

 { key:"sukkos", label:"Sukkos and Ushpizin", blurb:"Eight days of guests. Buy it by the case.", items:[
  P("Sweet Wine Mixed Case (12 bottles)","sweet-wine-mixed-case-12","32160969064541",119.99,"files/sweet-mixed-case-1000.jpg?v=1784664365",
    "Solve the whole week","Twelve bottles, mixed, at ten dollars each. One order and the sukkah is stocked.","12 bottles","Sweet",null),
  P("Psagot Cabernet Sauvignon (750ml)","psagot-cabernet-sauvignon-750ml","29468952330310",39.99,"files/psagot-cabernet-sauvignon-750ml.jpg?v=1783283095",
    "For the good night","Eight days of guests means one or two nights that matter more. Keep this back for those.","750ml","Dry",null),
  P("Domaine du Castel La Vie Rouge (750ml)","domaine-du-castel-la-vie-rouge-750ml","29478905708614",29.99,"files/la-vie-rouge-du-castel.jpg?v=1781705841",
    "Castel, at thirty dollars","The second label from one of Israel's best houses. Guests who know wine will notice.","750ml","Dry",null),
  P("GRW Alazani Valley (750ml)","grw-alazani-valley-750ml","43899542601946",21.99,"files/grw-alazani-valley-750ml.jpg?v=1782681430",
    "Something they have not had","Georgian semi-sweet is a real conversation starter, and it is not a risk.","750ml","Semi-sweet","Mevushal"),
  P("Binyamina Yogev Cabernet/Petit Verdot (750ml)","binyamina-yogev-cabernet-petit-verdot-750ml","29493280931910",18.99,"files/b13-30-binyamina-cpv.jpg?v=1782497433",
    "The case red","If you are buying six of one thing, this holds up across eight nights.","750ml","Dry","Not mevushal"),
  P("Teperberg Vision Cabernet (750ml)","teperberg-vision-cabernet-sauvignon-750ml","29492601454662",14.99,"files/teperberg-vision-cab.jpg?v=1782247365",
    "The everyday bottle","Israeli, dry, mevushal, fifteen dollars. Can sit open on a table all afternoon.","750ml","Dry","Mevushal")]},

 { key:"simchas", label:"Simchas Torah", blurb:"Our biggest season, and it is not wine", items:[
  P("Tubi 60 Original (750ml)","tubi-60-original-750ml","31268065607773",34.99,"files/tubi-60-original.jpg?v=1783024216",
    "Our number one bottle","The best selling product in the store, and top of Tishrei three years running.","750ml","Herbal liqueur",null),
  P("Joseph Gold Elite Arak (750ml)","joseph-gold-elite-arak-750ml","31552613679197",23.99,"files/joseph-gold-elite-arak.jpg?v=1783024934",
    "The l'chaim bottle","Second only to the Tubi, every year. It goes further at a kiddush than any wine.","750ml","Arak",null),
  P("Zachlawi Fig Arak (750ml)","zachlawi-fig-arak-750ml","29553298735174",36.99,"files/zachlawi-fig-arak-750ml.jpg?v=1782434004",
    "For the ones who know","Fig instead of anise, and a top four seller every Tishrei.","750ml","Arak",null),
  P("Askalon Arak (750ml)","arak-askalon-750ml","31552980353117",22.99,"files/askalon-arak.jpg?v=1783024934",
    "Keep a second one open","One bottle does not survive a real Simchas Torah. Buy two.","750ml","Arak",null),
  P("Boukha Bokobsa Fig Brandy (1L)","boukha-bokobsa-fig-brandy-1l","29557521023046",32.99,"files/boukha-bokobsa-fig-brandy-1l.jpg?v=1783090217",
    "The Tunisian one","A full litre of fig eau de vie. Older Sephardi guests will know it on sight.","1L","Brandy",null),
  P("Lautrec Cognac VSOP (750ml)","lautrec-cognac-vsop-grande-champagne-750ml","32310557900893",53.99,"files/lautrec-cognac-vsop.jpg?v=1783024935",
    "The bottle behind you","Grande Champagne cognac. Pour it for the people you actually want to sit with.","750ml","Cognac",null)]},

 { key:"gift", label:"The Gift", blurb:"Premium travels in Tishrei", items:[
  P("Domaine du Castel Grand Vin (750ml)","domaine-du-castel-grand-vin-750ml","29466192937030",112.99,"files/castel-grand-vin.jpg?v=1782247459",
    "Ends the argument","Israel's most respected house. Nobody is comparing it to anything else on the table.","750ml","Dry","Not mevushal"),
  P("Psagot Peak (750ml)","psagot-peak-750ml","29468997779526",52.99,"products/Psagot_Peak.jpg?v=1573057362",
    "Serious, not silly","Fifty dollars is the sweet spot: obviously considered, and it does not put the host in your debt.","750ml","Dry",null),
  P("Yatir Forest (1.5L)","yatir-forest-1-5l","44407914168538",244.99,"files/yatir-forest-1-5l.jpg?v=1783105716",
    "When it has to land","A Judean Hills magnum. Not a bottle of wine, a statement.","1.5L","Dry",null),
  P("Domaine du Castel Rose (750ml)","domaine-du-castel-rose-750ml","29413783011398",36.99,"files/castel-rose.jpg?v=1782253596",
    "Nobody else brings it","Premium rose is a real Tishrei seller and almost no one gives it in September.","750ml","Dry","Not mevushal"),
  P("Glenlivet Founder's Reserve (750ml)","glenlivet-founders-reserve-750ml","29441667661894",39.99,"files/glenlivet-founders-reserve-750ml.jpg?v=1782414425",
    "When wine is wrong","Plenty of hosts have twenty bottles they will never open. A single malt does not sit.","750ml","Scotch",null),
  P("Psagot Edom (750ml)","psagot-edom-750ml","29468922806342",49.99,"files/psagot-edom-750ml.jpg?v=1783283095",
    "The flagship","Psagot's top blend, French oak, built to age. For the host who actually cellars.","750ml","Dry",null)]},
];

/* handle -> product, for O(1) lookup from either page */
var ALL = {};
MOMENTS.forEach(function(m){ m.items.forEach(function(p){ ALL[p.h] = p; }); });

/* The blend a fresh case is seeded from: mevushal table wine that earns.
   Deliberately not the active tab, since the calculator sizes wine for
   MEALS and a 30 bottle case of $245 Yatir would be nonsense. */
var SEED = [
  {h:"rashi-joyvin-red-750ml",                    w:3},
  {h:"zmora-cabernet-sauvignon-semi-sweet-750ml", w:3},
  {h:"bartenura-moscato-750ml",                   w:2},
  {h:"bartenura-malvasia-di-casorzo-750ml",       w:2},
  {h:"grw-kindzmarauli-750ml",                    w:1},
  {h:"teperberg-vision-cabernet-sauvignon-750ml", w:1}
];
var SEED_W = SEED.reduce(function(a,x){ return a + x.w; }, 0);

/* ~1 bottle per 5 adults per meal, plus 2 spare */
function bottlesFor(adults, meals){ return Math.ceil((meals*adults)/5) + 2; }

/* Split n bottles across the seed blend by weight. Largest remainder, so the
   parts always add back to exactly n. Returns {handle: qty}. */
function seedCase(n){
  var raw = SEED.map(function(s){ return {h:s.h, exact:n*s.w/SEED_W}; });
  var qty = raw.map(function(x){ return Math.floor(x.exact); });
  var left = n - qty.reduce(function(a,x){ return a+x; }, 0);
  raw.map(function(x,i){ return {i:i, frac:x.exact - Math.floor(x.exact)}; })
     .sort(function(a,b){ return b.frac - a.frac; })
     .forEach(function(r){ if(left > 0){ qty[r.i]++; left--; } });
  var out = {};
  raw.forEach(function(x,i){ if(qty[i] > 0) out[x.h] = qty[i]; });
  return out;
}

/* ============================================================
   CASE STATE — shared between the banner and the portal.
   The banner collects, the portal finalises. Persisted so the
   handoff survives the page change, and so a customer who came
   back later still has their case.
   ============================================================ */
var KEY = "kwd_tishrei_case_v1";

function readCase(){
  try{
    var raw = localStorage.getItem(KEY);
    if(!raw) return {};
    var o = JSON.parse(raw), clean = {};
    // drop anything no longer in the catalog so a delisted SKU cannot
    // sit in someone's case forever and fail at add-to-cart
    Object.keys(o).forEach(function(h){
      if(ALL[h] && o[h] > 0) clean[h] = Math.min(999, Math.floor(o[h]));
    });
    return clean;
  }catch(e){ return {}; }
}
function writeCase(c){
  try{ localStorage.setItem(KEY, JSON.stringify(c)); }catch(e){}
  try{
    window.dispatchEvent(new CustomEvent("kwd:case", {detail:c}));
  }catch(e){}
}
function addToCase(handle, n){
  if(!ALL[handle]) return readCase();
  var c = readCase();
  c[handle] = (c[handle] || 0) + (n === undefined ? 1 : n);
  if(c[handle] <= 0) delete c[handle];
  writeCase(c);
  return c;
}
function setCase(c){ writeCase(c); return c; }
function clearCase(){ writeCase({}); return {}; }
function caseBottles(c){
  return Object.keys(c).reduce(function(a,h){ return a + c[h]; }, 0);
}
function caseSubtotal(c){
  return Object.keys(c).reduce(function(a,h){ return a + ALL[h].pr * c[h]; }, 0);
}

/* ============================================================
   ADD TO CART
   On the store: POST /cart/add.js then land on /cart so the
   customer reviews. Never a cart permalink there, because this
   store redirects permalinks straight into checkout and ignores
   return_to=/cart (verified against the live storefront).
   Off-domain (this prototype): the permalink is the only option.
   ============================================================ */
function cartLines(c){
  return Object.keys(c).map(function(h){
    return { id: Number(ALL[h].v), quantity: c[h] };
  });
}
function permalink(c){
  return "https://kosherwinedirect.com/cart/" + cartLines(c).map(function(l){
    return l.id + ":" + l.quantity;
  }).join(",");
}
function addToCart(c, opts){
  opts = opts || {};
  var lines = cartLines(c);
  if(!lines.length) return Promise.resolve({ok:false, reason:"empty"});

  if(STORE_HOST.test(location.hostname)){
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {"Content-Type":"application/json"},
      credentials: "same-origin",
      body: JSON.stringify({items: lines})
    }).then(function(r){
      if(!r.ok) throw new Error("cart/add.js " + r.status);
      if(opts.stay) return {ok:true, mode:"ajax"};
      location.href = "/cart";
      return {ok:true, mode:"ajax"};
    }).catch(function(err){
      // a failed AJAX add must not silently do nothing
      window.open(permalink(c), "_blank", "noopener");
      return {ok:true, mode:"permalink-fallback", error:String(err)};
    });
  }
  window.open(permalink(c), "_blank", "noopener");
  return Promise.resolve({ok:true, mode:"permalink"});
}

root.KWD = {
  CDN:CDN, SHOP:SHOP, MOMENTS:MOMENTS, ALL:ALL, SEED:SEED,
  bottlesFor:bottlesFor, seedCase:seedCase,
  readCase:readCase, setCase:setCase, addToCase:addToCase, clearCase:clearCase,
  caseBottles:caseBottles, caseSubtotal:caseSubtotal,
  cartLines:cartLines, permalink:permalink, addToCart:addToCart,
  onStore: function(){ return STORE_HOST.test(location.hostname); }
};
})(window);
